
import dayjs from "dayjs";

/**
 * Función que convierte un número de minutos
 * a su representación legible en horas, días, semanas,
 * meses y años. Por ejemplo:
 *
 * 72080 minuto(s) son 1 mes, 2 semanas, 6 días, 1 hora, 20 minutos
 *
 */
export const minToTime = (minutos) => {
  const leyenda = (numero, palabra, plural) =>
    numero === 0 || numero > 1
      ? `${numero} ${palabra}${plural || "s"}`
      : `${numero} ${palabra}`;
  const MINUTOS_POR_HORA = 60,
    HORAS_POR_DIA = 24,
    DIAS_POR_SEMANA = 7,
    DIAS_POR_MES = 30,
    MESES_POR_ANIO = 12;
  if (minutos < MINUTOS_POR_HORA) return leyenda(minutos, "minuto");
  let horas = Math.floor(minutos / MINUTOS_POR_HORA),
    minutosSobrantes = minutos % MINUTOS_POR_HORA;
  if (horas < HORAS_POR_DIA)
    return (
      leyenda(horas, "hora") +
      (minutosSobrantes > 0 ? ", " + minToTime(minutosSobrantes) : "")
    );
  let dias = Math.floor(horas / HORAS_POR_DIA);
  minutosSobrantes = minutos % (MINUTOS_POR_HORA * HORAS_POR_DIA);
  if (dias < DIAS_POR_SEMANA)
    return (
      leyenda(dias, "día") +
      (minutosSobrantes > 0 ? ", " + minToTime(minutosSobrantes) : "")
    );
  let semanas = Math.floor(horas / (HORAS_POR_DIA * DIAS_POR_SEMANA));
  minutosSobrantes =
    minutos % (MINUTOS_POR_HORA * HORAS_POR_DIA * DIAS_POR_SEMANA);
  if (dias < DIAS_POR_MES)
    return (
      leyenda(semanas, "semana") +
      (minutosSobrantes > 0 ? ", " + minToTime(minutosSobrantes) : "")
    );
  let meses = Math.floor(horas / (HORAS_POR_DIA * DIAS_POR_MES));
  minutosSobrantes =
    minutos % (MINUTOS_POR_HORA * HORAS_POR_DIA * DIAS_POR_MES);
  if (meses < MESES_POR_ANIO)
    return (
      leyenda(meses, "mes", "es") +
      (minutosSobrantes > 0 ? ", " + minToTime(minutosSobrantes) : "")
    );
  let anios = Math.floor(
    horas / (HORAS_POR_DIA * DIAS_POR_MES * MESES_POR_ANIO)
  );
  minutosSobrantes =
    minutos %
    (MINUTOS_POR_HORA * HORAS_POR_DIA * DIAS_POR_MES * MESES_POR_ANIO);
  return (
    leyenda(anios, "año") +
    (minutosSobrantes > 0 ? ", " + minToTime(minutosSobrantes) : "")
  );
};

export const convertTo2Digits = (num) => {
  return num.toString().padStart(2, "0");
};

export const formatDate = (dateParam) => {
  const date = convertToDate(dateParam);
  return [
    convertTo2Digits(date.getDate()),
    convertTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join("-");
};

export const formatDateReverse = (date) => {
  return [
    date.getFullYear(),
    convertTo2Digits(date.getMonth() + 1),
    convertTo2Digits(date.getDate()),
  ].join("-");
};

export function formatDateToNewDate(cadenaFecha) {
  if (typeof cadenaFecha === "object") {
    //if (validarFecha(cadenaFecha)) {

    cadenaFecha = formatDate(new Date(cadenaFecha));
  }

  //const cadenaFecha = "15-12-2024";
  // Dividimos la cadena en un array usando el separador "-"
  const [dia, mes, anio] = cadenaFecha.split("-");

  // Convertimos los valores a números y ajustamos el mes
  const fechaFormateada = new Date(anio, mes - 1, dia);

  return fechaFormateada;
}

export function convertToDate(date) {
  if(typeof date === 'number'){
    return new Date(date);
  }
  if(typeof date === 'string'){
    const [day, month, year] = date.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  if(dayjs.isDayjs(date)) {
    return date.toDate();
  }
  return date;
}

export function shortDateFormat(date) {
  return date instanceof Date ? dayjs(date).format("DD-MM-YYYY") : date;
}
